const icon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		x="0"
		y="0"
		viewBox="0 0 477.867 477.867"
	>
		<path
			fill="#f63d3d"
			d="M469.777 122.01a17.069 17.069 0 00-16.606-.751l-111.838 55.927v-40.653c0-28.277-22.923-51.2-51.2-51.2H51.2c-28.277 0-51.2 22.923-51.2 51.2v204.8c0 28.277 22.923 51.2 51.2 51.2h238.933c28.277 0 51.2-22.923 51.2-51.2V300.68l111.838 56.013c8.432 4.213 18.682.794 22.896-7.638a17.061 17.061 0 001.8-7.722v-204.8a17.065 17.065 0 00-8.09-14.523zM170.667 307.2c-37.703 0-68.267-30.564-68.267-68.267s30.564-68.267 68.267-68.267 68.267 30.564 68.267 68.267-30.565 68.267-68.267 68.267z"
		/>
	</svg>
);

export default icon;
